module.exports = __webpack_public_path__ + "img/interactivity.365aeeae.svg";